import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "22",
  viewBox: "0 0 23 22",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.2975 0H1.69805C0.75918 0 0 0.708984 0 1.58555V20.4102C0 21.2867 0.75918 22 1.69805 22H21.2975C22.2363 22 23 21.2867 23 20.4145V1.58555C23 0.708984 22.2363 0 21.2975 0ZM6.82363 18.7473H3.40957V8.2457H6.82363V18.7473ZM5.1166 6.81484C4.02051 6.81484 3.13555 5.96836 3.13555 4.92422C3.13555 3.88008 4.02051 3.03359 5.1166 3.03359C6.2082 3.03359 7.09316 3.88008 7.09316 4.92422C7.09316 5.96406 6.2082 6.81484 5.1166 6.81484ZM19.5994 18.7473H16.1898V13.6426C16.1898 12.4266 16.1674 10.8582 14.4154 10.8582C12.641 10.8582 12.3715 12.1859 12.3715 13.5566V18.7473H8.96641V8.2457H12.2367V9.68086H12.2816C12.7354 8.85586 13.8494 7.98359 15.507 7.98359C18.9615 7.98359 19.5994 10.1578 19.5994 12.9852V18.7473Z" }, null, -1)
  ]))]))
}
export default { render: render }